<template>
  <b-container fluid class="p-0 m-0 h-100" style="overflow: hidden">
    <b-row no-gutters style="height: calc(100%);">
      <b-col>
        <map-view-widget style="display: inline-block;" :style="{ width: 'calc(100% - ' + waterColumnDisplayWidth + 'px)' }" ref="map"></map-view-widget>
        <watercolumn-widget v-if="!isMobile" style="display: inline-block; border-left: 1px solid rgba(0, 0, 0, 0.125);" :style="{ width: waterColumnDisplayWidth + 'px' }" ref="watercolumn"></watercolumn-widget>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import MapViewWidget from '@/components/widgets/MapViewWidget'
import WatercolumnWidget from '@/components/widgets/WatercolumnWidget'

const MEDIUM_BREAKPOINT = 1024
const WIDTH_PER_PLATFORM = 72

export default {
  name: 'NavigatorWidget',
  data () {
    return {
      value: [20, 40]
    }
  },
  components: {
    WatercolumnWidget,
    // NavigatorHeaderWidget,
    // Slider,
    MapViewWidget
  },
  mounted: function () {
    this.set_collapse({ component: 'sidebar-watercolumn', value: true })
  },
  methods: {
    ...mapMutations(['set_collapse']),
    refreshViewport: function () {
      this.$refs.map.refreshViewport()
      if ('watercolumn' in this.$refs && typeof this.$refs.watercolumn !== 'undefined') {
        this.$refs.watercolumn.refreshViewport()
      }
    }
  },
  watch: {
    waterColumnDisplayWidth: {
      handler: function (val, oldVal) {
        this.refreshViewport()
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['platforms', 'collapseStates']),
    ...mapGetters(['campaignSelected']),
    isMobile: function () {
      return this.$root.window.width <= MEDIUM_BREAKPOINT
    },
    divingPlatformsCount: function () {
      let count = 0
      for (const platformId in this.platforms) {
        const platform = this.platforms[platformId]
        if ((platform.type.toLowerCase() === 'auv-g500' ||
          platform.type.toLowerCase() === 'transponder') &&
          'watercolumn' in platform && 'last_change' in platform &&
          this.campaignSelected.platforms.includes(Number(platformId))) {
          count++
        }
      }
      return count
    },
    waterColumnDisplayWidth: function () {
      if (this.collapseStates['sidebar-watercolumn'] && this.divingPlatformsCount > 0) {
        return WIDTH_PER_PLATFORM
      } else {
        return this.divingPlatformsCount * WIDTH_PER_PLATFORM
      }
    }
  }
}

</script>
